import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { Link, useParams, useLocation } from 'react-router-dom'
import config from '../coreFIles/config'
import { getsidebarMenuAction, getbannerAdsAction, logBannerClickAction, catDetailsAction, getadDataFromSidesAction } from '../Action/action';
const Domainid = (!Cookies.get('domain_id')) ? [] : JSON.parse(Cookies.get('domain_id'));
const ageVerified = (!Cookies.get('ageVerified')) ? false : Cookies.get('ageVerified');

const Rightsidebar = () => {

    const { id } = useParams();
    const location = useLocation();
	const [bannerAds, setbannerAds]	= useState({});
    const [parentCatId, setParentCatId] = useState(null);
    const [adParentCatId, setAdParentCatId] = useState(null);
    const [adCategoryId, setAdCategoryId] = useState(null);
	useEffect(() => {
		getbannerAds();
	}, [])
	
    const getbannerAds = async () => {
		let res = await getbannerAdsAction({adColumn:'R'});
		if (res.success) {
			setbannerAds(res.data);
		}
	};

    useEffect(() => {
        if (id) {
            (async () => {
                try {
                    // Check if we're on ad details page
                    const isAdDetailsPage = location.pathname.includes('/ad/');
                    if (isAdDetailsPage) {
                        // On ad details page, get parent_cat_id from ad data
                        const adRes = await getadDataFromSidesAction({ id: id, any: '' });
                        if (adRes && adRes.success && adRes.data && typeof adRes.data.parent_cat_id !== 'undefined') {
                            setAdParentCatId(parseInt(adRes.data.parent_cat_id));
                            setParentCatId(parseInt(adRes.data.parent_cat_id));
                            if (typeof adRes.data.category_id !== 'undefined') {
                                setAdCategoryId(String(adRes.data.category_id));
                            } else {
                                setAdCategoryId(null);
                            }
                        } else {
                            setAdParentCatId(null);
                            setParentCatId(null);
                            setAdCategoryId(null);
                        }
                    } else {
                        // On category page, get parent_id from category data
                        const res = await catDetailsAction({ catId: id, any: 'action' });
                        if (res && res.success && res.data && typeof res.data.parent_id !== 'undefined') {
                            setParentCatId(parseInt(res.data.parent_id));
                        } else {
                            // In view-all pages, id itself is the parent category id
                            const numericId = parseInt(id);
                            setParentCatId(!isNaN(numericId) ? numericId : null);
                        }
                        setAdParentCatId(null);
                        setAdCategoryId(null);
                    }
                } catch (e) {
                    setParentCatId(null);
                    setAdParentCatId(null);
                    setAdCategoryId(null);
                }
            })();
        } else {
            setParentCatId(null);
            setAdParentCatId(null);
            setAdCategoryId(null);
        }
    }, [id, location.pathname])

	const handleBannerClick = async (row, evt) => {
		if (evt && evt.preventDefault) evt.preventDefault();
		try {
			const res = await logBannerClickAction({ ad_id: row.ad_id, type: 1, metrocity: Domainid?.domain_id || 0 });
			if (row.ad_url) {
				window.open(row.ad_url, '_blank', 'noopener');
			}
		} catch (e) { /* noop */ }
	};
	
	return (
		<>
			<div className="right-section">
				<div className="map-section ">
					<a href = {config.baseUrl}>
					{ 
					!document.cookie.includes("domain_id")  ? 
					<img src={config.baseUrl + "img/map-img.png"} alt='map' />:""
					}
					</a>
				</div>
				<div className="towblock">
					{bannerAds.length > 0 ? (
                        bannerAds.map((row, index) => {
                            const ad_pages = row?.ad_pages || '';
                            const pagesArray = ad_pages.split(',').filter(Boolean);
                            const includesOne = pagesArray.includes('1');
                            const isVerified = (ageVerified === 'true' || ageVerified === true);
                            const allowSensitive = isVerified && ((String(id) === '1') || (parentCatId === 1) || (adParentCatId === 1));
                            // Determine page context
                            const pathname = location.pathname || '';
                            const isHome = pathname === '/' || pathname === '';
                            const isGeneralPage = ['about', 'contact-us', 'rssfeeds', 'sharewithfriend', 'vipmembership'].some(p => pathname.includes(`/${p}`));
                            const isAdListingPage = pathname.startsWith('/cat');
                            const isAdDetailPage = pathname.startsWith('/ad/');
                            // Side match: B for both, or explicit side R
                            const adColumn = (row.ad_column || '').toUpperCase();
                            const sideMatches = adColumn === 'B' || adColumn === 'R' || adColumn === '';
                            // For ad details/listing pages, match ad_pages with category id or parent id
                            const categoryMatch = (adCategoryId && pagesArray.includes(String(adCategoryId))) || (parentCatId && pagesArray.includes(String(parentCatId)));
                            // Base visibility by page type and flags
                            let baseVisible = false;
                            if (isHome) {
                                baseVisible = (row.onhome === 1) || (row.ad_allpages === 1);
                            } else if (isGeneralPage) {
                                baseVisible = (row.ad_genpages === 1) || (row.ad_allpages === 1);
                            } else if (isAdListingPage) {
                                baseVisible = (row.ad_allpages === 1) || categoryMatch;
                            } else if (isAdDetailPage) {
                                baseVisible = (row.ad_allpages === 1) || categoryMatch;
                            } else {
                                baseVisible = (row.ad_allpages === 1);
                            }

                            let shouldRender = false;
                            if (!isVerified) {
                                shouldRender = pagesArray.includes('46') && !includesOne && row.ad_type === 'img' && baseVisible && sideMatches;
                            } else {
                                if (isAdListingPage || isAdDetailPage) {
                                    // Check both parentCatId and adParentCatId for personals context
                                    const personalsContext = (parseInt(parentCatId) === 1) || (parseInt(adParentCatId) === 1);
                                    if (personalsContext) {
                                        // Show only personals banners (must include '1' in ad_pages)
                                        shouldRender = includesOne && row.ad_type === 'img' && baseVisible && sideMatches;
                                    } else {
                                        // Show only non-personal banners (must NOT include '1' in ad_pages)
                                        shouldRender = !includesOne && row.ad_type === 'img' && baseVisible && sideMatches;
                                    }
                                } else {
                                    if (includesOne && allowSensitive) {
                                        shouldRender = row.ad_type === 'img' && baseVisible && sideMatches;
                                    } else if (!includesOne) {
                                        shouldRender = row.ad_type === 'img' && baseVisible && sideMatches;
                                    } else {
                                        shouldRender = false;
                                    }
                                }
                            }

                            if (!shouldRender) return null;

                            return (
                                <div className="heroimg" key={index}>
                                    <a href="javascript:;" onClick={(e) => handleBannerClick(row, e)} title={row.ad_title || 'Banner ad'}>
                                        <img src={config.bannersUrl + row.ad_file} alt={row.ad_title || 'Banner ad'} style={{ width: '100%', height: 'auto', maxWidth: '100%' }} />
                                    </a>
                                </div>
                            );
                        })
                    ) : ''}
                </div>
			</div>
		</>
	)
}

export default Rightsidebar;
